export const DEFAULT_EMPTY_TOTAL_RESULTS = 0
export const LEGACY_WRAPPER = 'legacy'
